function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { NavLink } from 'react-router';
import { Badge, HubTooltip, useCallout } from '@arc/frontend/ui-common';
import { su, theme } from '@arc/frontend/ui-theme';
export const navItemStyles = {
  navLink: /*#__PURE__*/css(su.textSm, {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    textDecoration: 'none',
    paddingTop: '2px',
    borderBottom: '2px solid transparent',
    color: '#fff',
    transition: 'all 0.2s ease-in-out',
    whiteSpace: 'nowrap',
    '&:not([data-disabled=true]):hover': {
      textShadow: '0px 0px 4px #0000001f'
    },
    '&.active': {
      fontWeight: '700',
      textShadow: '0px 0px 4px #00000040',
      borderBottom: `2px solid ${theme.colors.background.navItemActive}`
    },
    '&[data-disabled=true]': /*#__PURE__*/css({
      color: theme.colors.text.faint,
      fontWeight: '300',
      cursor: 'default'
    }, process.env.NODE_ENV === "production" ? "" : ";label:--data-disabled-true-;")
  }, process.env.NODE_ENV === "production" ? "" : ";label:navLink;"),
  navLinkNarrow: process.env.NODE_ENV === "production" ? {
    name: "1ovycbe",
    styles: "padding-left:0.75rem;padding-right:0.75rem"
  } : {
    name: "b81fl4-navLinkNarrow",
    styles: "padding-left:0.75rem;padding-right:0.75rem;label:navLinkNarrow;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function NavItem(props) {
  const {
    children,
    disabled,
    disabledCalloutText,
    narrow,
    onClick,
    alternativeAction,
    badge,
    calloutText,
    ...other
  } = props;
  const {
    callout,
    setShowViewCallout
  } = useCallout({
    text: disabledCalloutText ?? ''
  });
  const childrenContent = typeof children === 'function' ? 'Nav Item' : children;
  const content = badge ? <Badge count={badge.count} color={badge.color} variant={badge.variant} backgroundColor={badge.backgroundColor} textColor={badge.textColor}>
			<span>{childrenContent}</span>
		</Badge> : childrenContent;
  const navContent = calloutText ? <HubTooltip title={calloutText}>
			<span>{content}</span>
		</HubTooltip> : content;
  return <>
			<NavLink css={[navItemStyles.navLink, narrow && navItemStyles.navLinkNarrow, process.env.NODE_ENV === "production" ? "" : ";label:NavItem;"]}
    // Using data-disabled instead to allow for cursor events to propagate
    data-disabled={disabled} data-testid={typeof children === 'string' ? `header-${children}` : undefined} onClick={e => {
      if (disabled) {
        setShowViewCallout(e);
        e.preventDefault();
      } else if (alternativeAction) {
        alternativeAction();
        e.preventDefault();
      }
      onClick?.(e);
    }} {...other}>
				{navContent}
			</NavLink>
			{callout}
		</>;
}